<template>
  <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
    <div class="vx-row" :class="{ 'cursor-drag': draggingCard === true }">
      <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
        <vx-card class="mb-base">
          <h3 class="font-bold mb-4">Commands</h3>
          <vue-draggable-container id="wordBank" class="wordBank min-h-0">
            <h5 class="dragBlock font-semibold cursor-pointer h-max-content" v-for="block in dragBlocks">{{ block }}</h5>
          </vue-draggable-container>
        </vx-card>
      </div>
      <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5" :class="{ 'cursor-drag': draggingCard === true }">
        <div class="flex flex-col justify-between rounded-lg bg-dark main-border">
          <span class="flex items-center p-4">
            <h3 class="font-bold main-bottom-border w-1/2">Command Order</h3>
            <h3 class="font-bold main-bottom-border w-1/2">SSH Client</h3>
          </span>

          <div class="flex flex-col items-center gap-y-3 p-4">
            <div class="flex items-center gap-x-3 w-full">
              <div class="vx-col w-1/2 flex items-center">
                <img
                  draggable="false"
                  src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/189086389025898496/number-one.png"
                  width="40"
                  class="mr-4"
                />
                <h4 class="font-bold">Command #1</h4>
              </div>

              <vue-draggable-container class="w-1/2 answerStandard dropzone dropzoneStandard answer-bg" id="input0" />
            </div>

            <div class="flex items-center gap-x-3 w-full">
              <div class="vx-col w-1/2 flex items-center">
                <img
                  draggable="false"
                  src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/189086389025898496/number-two.png"
                  width="40"
                  class="mr-4"
                />
                <h4 class="font-bold">Command #2</h4>
              </div>

              <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-1/2" id="input1" />
            </div>

            <div class="flex items-center gap-x-3 w-full">
              <div class="vx-col w-1/2 flex items-center">
                <img
                  draggable="false"
                  src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/189086389025898496/number-three.png"
                  width="40"
                  class="mr-4"
                />
                <h4 class="font-bold">Command #3</h4>
              </div>

              <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-1/2" id="input2" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </vue-sortable>
</template>

<script>
import draggable from 'vuedraggable';
import Prism from 'vue-prism-component';
import shuffle from 'shuffle-array';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      dragBlocks: [
        'chmod 777 ~/.ssh/authorized_keys',
        'ssh-keygen -t rsa',
        'scp ~/.ssh/id_rsa user@server:.ssh/private/public_keys',
        'ssh -i ~/.ssh/id_rsa user@server',
        'openssl x509 -in ~/.ssh/id_rsa.pub -text -noout@server',
        'ssh-copy-id -i ~/.ssh/id_rsa.pub user@server',
        'ssh root@server@user',
      ],

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard',
      },
    };
  },
  methods: {
    startedDrag(x) {
      x.data.source.className += ' currently-dragging-standard';
      this.draggingCard = true;
    },
    stoppedDrag() {
      this.draggingCard = false;
    },
    sort(x) {
      const overContainer = x.data.dragEvent.data.overContainer;
      const sourceContainer = x.data.dragEvent.data.sourceContainer;
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          x.cancel();
        }
      }
    },
    markSimulation() {
      let total_score = 0;

      if (document.getElementById('input0').textContent === 'ssh-keygen -t rsa') {
        document.getElementById('input0').style.borderColor = '#28C76F';
        document.getElementById('input0').style.backgroundColor = '#28C76F';
        total_score++;
      } else {
        document.getElementById('input0').style.borderColor = '#fd4445';
        document.getElementById('input0').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input1').textContent === 'ssh-copy-id -i ~/.ssh/id_rsa.pub user@server') {
        document.getElementById('input1').style.borderColor = '#28C76F';
        document.getElementById('input1').style.backgroundColor = '#28C76F';
        total_score++;
      } else {
        document.getElementById('input1').style.borderColor = '#fd4445';
        document.getElementById('input1').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input2').textContent === 'ssh -i ~/.ssh/id_rsa user@server') {
        document.getElementById('input2').style.borderColor = '#28C76F';
        document.getElementById('input2').style.backgroundColor = '#28C76F';
        total_score++;
      } else {
        document.getElementById('input2').style.borderColor = '#fd4445';
        document.getElementById('input2').style.backgroundColor = '#fd4445';
      }

      if (total_score === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', total_score);
      }

      this.$emit('simulation_getting_there', total_score);
    },
  },
  created() {
    this.dragBlocks = shuffle(this.dragBlocks);
  },
  components: {
    draggable,
    Prism,
    shuffle,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
#wordBank {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 0.6rem;
}
</style>
